import { ElementType, LogicalType, ConditionType, ActionType } from "@/@types/entities/forms";

export const TextByLogical: Record<LogicalType, string> = {
  [LogicalType.Anyone]: "Cualquiera",
  [LogicalType.Everyone]: "Todos",
};

export function getTextByCondition(conditionType?: ConditionType, inputType?: ElementType) {
  if (!conditionType) return "";

  const text: Record<ConditionType, string> = {
    [ConditionType.Contains]: "Contiene",
    [ConditionType.NoContains]: "No contiene",
    [ConditionType.BeginsWith]: "Empieza con",
    [ConditionType.NoBeginsWith]: "No empieza con",
    [ConditionType.EndsWith]: "Termina con",
    [ConditionType.NoEndsWith]: "No termina con",
    [ConditionType.IsEmpty]: inputType === ElementType.File ? "Sin archivo" : "Está vacío",
    [ConditionType.NoEmpty]: inputType === ElementType.File ? "Con archivo" : "Está completo",
    [ConditionType.IsEqual]: "Es igual",
    [ConditionType.NoEqual]: "No es igual",
    [ConditionType.IsBefore]: "Antes",
    [ConditionType.IsAfter]: "Después",
  };

  return text[conditionType];
}

export const TextByAction: Record<ActionType, string> = {
  [ActionType.Hide]: "Ocultar",
  [ActionType.Show]: "Mostrar",
  [ActionType.Require]: "Requerir",
  [ActionType.NoRequire]: "No requerir",
  [ActionType.Enable]: "Habilitar",
  [ActionType.Disable]: "No habilitar",
};
